import { Feature } from '../../../../types/catalog';
import { Fragment } from 'react';

function FeatureTable({ features, title }: { features: Feature[]; title: string }) {
    return (
        <Fragment>
            <div className="iek-prodcat-catalog-detail-docs__title">{title}</div>
            <table className="feature-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                    {features.map(({ id, name, value, unit }) => (
                        <tr key={id || name}>
                            <td>{name}</td>
                            <td>
                                {value} {unit}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </Fragment>
    );
}

export default FeatureTable;
